import { Ng2StateDeclaration } from '@uirouter/angular';
import { RoleEditComponent } from '@fi-app/role/role-edit/role-edit.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiRoleStateResolveAllRoles } from '@fi-app/role/states/resolve/all-roles';
import { FiRoleStateResolveRole } from '@fi-app/role/states/resolve/role';
import { FiRoleStateResolveExtendedRoleRoles } from '@fi-app/role/states/resolve/extended-role-roles';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiRoleAddState: Ng2StateDeclaration = {
    name: FiStateNames.Role.Add,
    url: '/Add',
    views: {
        '@': {
            component: RoleEditComponent,
        },
    },
    resolve: {
        role: FiRoleStateResolveRole,
        extendedRoleRight: [FiRoleAddStateResolve_extendedRoleRight],
        allRoles: FiRoleStateResolveAllRoles,
        extendedRoleRoles: FiRoleStateResolveExtendedRoleRoles,
        pageTitle: [PageTitleService, 'role', FiRoleAddStateResolve_pageTitle],
    },
};

export function FiRoleAddStateResolve_extendedRoleRight() {
    return false;
}

export function FiRoleAddStateResolve_pageTitle(ccmPageTitle: PageTitleService, Role) {
    return ccmPageTitle.setTitleByItem(Role);
}
